import { Table } from '@sketchpixy/rubix';
import React from 'react';
import _ from 'lodash';

import MgfRowComponent from './mgfRow';

export default class MgfTableComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	removeHiddenFields(fields) {
		return _.omit.apply(this, [fields].concat(_.reduce(fields, (acc, field, key) => {
			if (field.hide === true || key.match(/(.*)\.\$/))
				acc.push(key);
			return acc;
		}, [])));
	}

	renderHeader() {
		return _.map(this.removeHiddenFields(this.props.fields), (field, key) => (
			<th key={key}>{field.label}</th>
		));
	}

	renderRows() {
		return this.props.list.map((item, index) => (
			<MgfRowComponent key={index} item={item} fields={this.removeHiddenFields(this.props.fields)} type={this.props.type} />
		));
	}

	render() {
		return (
			<Table responsive>
				<thead>
					<tr>
						{this.renderHeader()}
						<th key="actions">Actions</th>
					</tr>
				</thead>
				<tbody>
					{this.renderRows()}
				</tbody>
			</Table>
		);
	}
}

MgfTableComponent.propTypes = {
	list: React.PropTypes.array.isRequired,
	fields: React.PropTypes.object.isRequired,
	type: React.PropTypes.string.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/common/mgfTable.js
 **/